import { render } from "./Footer.vue?vue&type=template&id=75418b3c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=75418b3c&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/bob-web/bob-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75418b3c"]])

export default __exports__